import React from 'react';

import { AUTH_USER_LINKEDIN_START } from 'api/routes';
import { api } from 'utils/api';
import { LINKEDIN_FLOW_STORAGE_KEY } from 'client/redux/user/actions/linkedin-flow';

type Props = {
  onSuccess: () => unknown;
};

const LinkedInProvider: React.FC<Props> = () => {
  React.useEffect(() => {
    const init = async () => {
      const verifier = Array.from(window.crypto.getRandomValues(new Uint8Array(32)), (byte) =>
        byte.toString(16).padStart(2, '0')
      ).join('');
      const verifierBytes = new TextEncoder().encode(verifier);
      const hash = await window.crypto.subtle.digest('SHA-256', verifierBytes);
      const verifierHash = Array.from(new Uint8Array(hash), (byte) => byte.toString(16).padStart(2, '0')).join('');
      const response = await api.sendRequest<{ authorizationUrl: string; state: string }>({
        url: AUTH_USER_LINKEDIN_START,
        method: 'GET',
        data: { verifierHash },
      });

      if (!response.success) throw new Error('LinkedInSignInStartFailed');

      window.sessionStorage.setItem(
        LINKEDIN_FLOW_STORAGE_KEY,
        JSON.stringify({ state: response.data.state, verifier })
      );
      window.location.assign(response.data.authorizationUrl);
    };

    init().catch((error) => console.error('LinkedIn sign-in start failed', error));
  }, []);

  return null;
};

export default LinkedInProvider;
